import { Component } from "react";
import styles from './text-input.module.scss'

export interface TextInputValueChangeEvent {
    inputValue: any;
}

interface TextInputComponentProps {
    label: string;
    inputValue: any;
    valueChanged: (a: TextInputValueChangeEvent) => void
}

interface TextInputComponentState {
    inputValue: any;
    prevInputValue: any;
}

export class TextInputComponent extends Component<TextInputComponentProps, TextInputComponentState> {
    state: Readonly<TextInputComponentState> = {
        inputValue: this.props.inputValue,
        prevInputValue: this.props.inputValue
    };

    static getDerivedStateFromProps(props: TextInputComponentProps, state: TextInputComponentState) {
        if (props.inputValue !== state.prevInputValue) {
            return {
                inputValue: props.inputValue,
                prevInputValue: props.inputValue
            };
        }
        return null;
    }
    constructor(props) {
        super(props)
    }

    inputChanged(e) {
        this.setState({
            inputValue: e.target.value
        });
        this.props.valueChanged({
            inputValue: e.target.value,
        });
    }

    render() {
        return <div className={styles['container']}>
            {
                this.props.label && <div className={`${styles['label']} text-flex-vertical-center`}>
                    {this.props.label}
                </div>
            }
            <div className={`${styles['text-input']} x-input-group input-group-md`}>
                <input className="form-control"
                    onInput={e => this.inputChanged(e)}
                    type={"text"}
                    value={this.state.inputValue} />
            </div>
        </div>
    }
}